package app.bloomey.web.core.data.models

import kotlinx.serialization.Serializable

@Serializable
data class TimesSeriesData<T>(
    val id: String,
    val timeStamp: kotlinx.datetime.LocalDateTime,
    val metaData: T,
)